import { requests } from 'api';
import { District } from './types';

const apiBaseUrl = '/api/districts';

export const DistrictsApi = {
  getAll: (): Promise<District[]> => requests.get(apiBaseUrl),
};
